import { useEffect } from 'react';
import type { Announcement } from '@caro/shared/types';
import { useApi } from './useApi';
import { onAnnouncementsChanged } from '../services/announcementsEvents';

/**
 * Aankondigingen van dit gebouw, met tekst per taal als de API die meestuurt
 * (specs/20261016-taal-bewonersapp, T031c/T037c).
 *
 * Haalt de lijst opnieuw op zodra de server `announcements_changed` stuurt, zodat een
 * aankondiging uit het portaal zonder herladen op de tablet staat.
 */
export type ResidentAnnouncement = Announcement & {
  baseLanguage?: string | null;
  siteLanguage?: string | null;
  translations?: Partial<Record<string, { title?: string; body?: string }>> | null;
};

export function useAnnouncements(tenantId: number | string | null | undefined) {
  const { data, refetch } = useApi<ResidentAnnouncement[]>(
    tenantId ? `/api/v1/building/${tenantId}/announcements` : null,
  );
  useEffect(() => onAnnouncementsChanged(() => { void refetch(); }), [refetch]);
  return { announcements: data, refetch };
}
